/* ==================== Wishlist (localStorage-based) ==================== */
(function () {
  var STORAGE_KEY = 'wishlist_product_ids';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(ids) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { ids: ids } }));
  }

  function isWishlisted(id) {
    return getWishlist().indexOf(String(id)) !== -1;
  }

  function toggleWishlist(id) {
    var ids = getWishlist();
    var idx = ids.indexOf(String(id));
    if (idx === -1) {
      ids.push(String(id));
    } else {
      ids.splice(idx, 1);
    }
    saveWishlist(ids);
    return idx === -1; // true = now wishlisted
  }

  function refreshButtonState(btn) {
    var id = btn.getAttribute('data-product-id');
    var active = isWishlisted(id);
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
  }

  function initWishlistButtons() {
    var buttons = document.querySelectorAll('[data-wishlist-toggle]');
    buttons.forEach(function (btn) {
      refreshButtonState(btn);
      if (btn.dataset.wishlistBound === 'true') return;
      btn.dataset.wishlistBound = 'true';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = btn.getAttribute('data-product-id');
        toggleWishlist(id);
        refreshButtonState(btn);
      });
    });
  }

  document.addEventListener('wishlist:updated', function () {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(refreshButtonState);
  });

  document.addEventListener('DOMContentLoaded', initWishlistButtons);
  document.addEventListener('shopify:section:load', initWishlistButtons);
  window.initWishlistButtons = initWishlistButtons;
})();

/* ==================== Product Video Modal ==================== */
(function () {
  function buildEmbed(url) {
    var youtubeMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]+)/);
    var vimeoMatch = url.match(/vimeo\.com\/(\d+)/);

    if (youtubeMatch) {
      var ytId = youtubeMatch[1];
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube.com/embed/' + ytId + '?autoplay=1&rel=0';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.setAttribute('frameborder', '0');
      return iframe;
    }

    if (vimeoMatch) {
      var vimeoId = vimeoMatch[1];
      var vIframe = document.createElement('iframe');
      vIframe.src = 'https://player.vimeo.com/video/' + vimeoId + '?autoplay=1';
      vIframe.allow = 'autoplay; fullscreen; picture-in-picture';
      vIframe.allowFullscreen = true;
      vIframe.setAttribute('frameborder', '0');
      return vIframe;
    }

    // Fall back to a direct video file (e.g. .mp4)
    var video = document.createElement('video');
    video.src = url;
    video.controls = true;
    video.autoplay = true;
    video.playsInline = true;
    return video;
  }

  function openModal(wrapper, url) {
    var modal = wrapper.querySelector('.product-video-modal');
    var player = wrapper.querySelector('[data-video-player]');
    if (!modal || !player) return;
    player.innerHTML = '';
    player.appendChild(buildEmbed(url));
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeModal(wrapper) {
    var modal = wrapper.querySelector('.product-video-modal');
    var player = wrapper.querySelector('[data-video-player]');
    if (!modal) return;
    modal.hidden = true;
    if (player) player.innerHTML = '';
    document.body.style.overflow = '';
  }

  function initProductVideo() {
    document.querySelectorAll('[data-product-video-wrapper]').forEach(function (wrapper) {
      if (wrapper.dataset.videoBound === 'true') return;
      wrapper.dataset.videoBound = 'true';

      var trigger = wrapper.querySelector('.product-video-trigger');
      if (trigger) {
        trigger.addEventListener('click', function () {
          openModal(wrapper, trigger.getAttribute('data-video-url'));
        });
      }

      wrapper.querySelectorAll('[data-video-close]').forEach(function (closeEl) {
        closeEl.addEventListener('click', function () {
          closeModal(wrapper);
        });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeModal(wrapper);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initProductVideo);
  document.addEventListener('shopify:section:load', initProductVideo);
  window.initProductVideo = initProductVideo;
})();
